<template>
  <div class="inputs-holder">
    <span v-if="prefix" class="prefix">{{ prefix }}</span>
    <div
      v-for="(field, index) in fields"
      :key="index"
      :class="{
        single: fields.length === 1 && !prefix,
        'single-with-prefix': fields.length === 1 && prefix,
        multiple: fields.length > 1
      }"
    >
      <input
        class="inp grey-field"
        type="text"
        :maxlength="field.maxLength || 32"
        :placeholder="
          fields.length === 1 && !field.placeholder
            ? 'max 32 karakters'
            : field.placeholder
        "
        :readonly="isReadonly"
        ref="field"
        :value="values[index]"
        @keyup="inputCheck(index)"
        :class="{
          invalid: valid[index] === false,
          pointer: isReadonly && isRequired
        }"
      /><span v-if="index < fields.length - 1">{{ projectHyphen }}</span>
    </div>
  </div>
</template>

<script>
/**
 * Multi Inputs component
 *
 * Properties:
 *
 * - fields : Array of Field Objects: [{
 *      format : regEx,
 *      maxLength : String,
 *      placeholder : String
 *  }]
 * - hyphen : hyphen symbol String
 * - projectName : String
 * - isRequired : Boolean
 * - isReadonly : Boolean
 *
 */

export default {
  props: {
    fields: { type: Array, default: () => [] },
    hyphen: { type: String, default: '-' },
    projectName: { type: String, default: '' },
    isRequired: { type: Boolean, default: false },
    isReadonly: { type: Boolean, default: false },
    type: { type: String },
    prefix: { type: String, default: '' }
  },
  data() {
    return {
      // valid: []
    }
  },
  computed: {
    projectHyphen() {
      if (this.fields.length === 1) {
        return undefined
      } else if (this.hyphen === '') {
        return '-'
      } else {
        return this.hyphen
      }
    },
    projectNameWithoutPrefix() {
      if (this.prefix && this.projectName.startsWith(this.prefix)) {
        return this.projectName.slice(this.prefix.length)
      }
      return this.projectName
    },
    values() {
      let values = []
      if (this.fields.length > 1) {
        const parts = this.projectNameWithoutPrefix.split(this.projectHyphen)
        parts.forEach((item, key) => {
          values[key] = item
        })
      } else {
        values[0] = this.projectNameWithoutPrefix
        //        this.$set(this.values, 0, this.projectName)
      }

      return values
    },
    valid() {
      let valid = []
      // if (this.fields.length > 1) {
      for (let i = 0; i < this.fields.length; i++) {
        const format = this.fields[i].format
          ? new RegExp(this.fields[i].format)
          : ''

        if (
          this.isRequired &&
          this.fields.length === 1 &&
          (!this.values[0] || this.values[0].length == 0)
        ) {
          valid[0] = false
        } else if (format) {
          if (!this.values[i]) {
            this.values[i] = ''
          }
          valid[i] = format.test(this.values[i])
        } else {
          valid[i] = true
        }
      }
      return valid
      //  }
    }
  },
  methods: {
    inputCheck(index) {
      const inputField = this.$refs.field?.[index]
      if (!inputField) return

      let newProject = ''

      if (this.fields.length === 1) {
        newProject = inputField.value
        this.$emit(
          'setProject',
          this.prefix ? this.prefix + newProject : newProject
        )
      } else if (this.fields.length > 1) {
        // set focus to next field
        let lastIndex = this.fields.length - 1
        const nextFieldIndex =
          lastIndex === index ? 0 : this.$refs.field[index + 1]
        if (
          inputField.value.length === inputField.maxLength &&
          nextFieldIndex
        ) {
          this.$refs.field[index + 1].focus()
        }

        let currentProjectParts = this.projectNameWithoutPrefix.split(this.projectHyphen)
        currentProjectParts[index] = inputField.value
        newProject = currentProjectParts.join(this.projectHyphen)

        if (!inputField.value) {
          var re = new RegExp(this.projectHyphen + '\s*$')
          newProject = newProject.replace(re, '')
        }

        this.$emit(
          'setProject',
          this.prefix ? this.prefix + newProject : newProject
        )
      }
    }
  },
  watch: {
    valid: function (valid) {
      if (
        valid.some((value) => {
          return value === false
        })
      ) {
        this.$emit('add-error')
      } else {
        this.$emit('remove-error')
      }
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.inputs-holder {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .prefix {
    margin-right: 4px;
    padding-bottom: 9px;
    white-space: nowrap;
  }
  div {
    padding-bottom: 10px;
    white-space: nowrap;

    &.single {
      flex-basis: 100%;

      input.inp:read-only {
        padding: 0 10px 0 0;
        text-overflow: ellipsis;
      }
    }

    &.single-with-prefix {
      flex: 1;

      input.inp:read-only {
        padding: 0 10px 0 0;
        text-overflow: ellipsis;
      }
    }

    &.multiple {
      flex-basis: 105px;

      input.inp {
        width: calc(100% - 15px);
      }
    }

    input.inp {
      margin-right: 0;
      width: 100%;
    }

    span {
      display: inline-block;
      width: 15px;
      text-align: center;
    }
  }
}
</style>
